import { render, staticRenderFns } from "./HomeButton.vue?vue&type=template&id=0b682163&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b682163",
  null
  
)

export default component.exports